function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_metro-cross",
  "data-name": "Icon metro-cross",
  d: "M35.252,28.425h0L25.246,18.419,35.251,8.413h0a1.033,1.033,0,0,0,0-1.457L30.525,2.229a1.033,1.033,0,0,0-1.457,0h0L19.062,12.235,9.056,2.229h0a1.033,1.033,0,0,0-1.457,0L2.872,6.956a1.033,1.033,0,0,0,0,1.457h0L12.878,18.419,2.872,28.425h0a1.033,1.033,0,0,0,0,1.457L7.6,34.609a1.033,1.033,0,0,0,1.457,0h0L19.062,24.6,29.067,34.609h0a1.033,1.033,0,0,0,1.457,0l4.727-4.727a1.033,1.033,0,0,0,0-1.457Z",
  transform: "translate(-2.571 -1.928)",
  fill: "#f52b2b"
});

function SvgIconmetroCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.982,
    height: 32.982,
    viewBox: "0 0 32.982 32.982",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmetroCross);
export default __webpack_public_path__ + "static/media/Icon metro-cross.5a994118.svg";
export { ForwardRef as ReactComponent };